import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/layout';
// import Seo from '../components/seo';


import { BlogMainScreen, BlogItems, CrumbsNav } from '../components/Pages/Blog';

import { blogStatic } from '../db/blogStatic';

const blogCategory = ({data}) => {

  const articles = data.article.edges
  const blogDatas = data.strapiBlog
  return (
    <Layout>
      {/* <Seo 
        title={langToggle(blogDatas.seo_title_ua, blogDatas.seo_title_ru)}
        description={langToggle(blogDatas.seo_description_ua, blogDatas.seo_description_ru)} 
      /> */}
      <BlogMainScreen mainData={blogDatas.main} categoryData={data.allStrapiCategory.nodes} />
      <BlogItems articlesData={articles} />
      <CrumbsNav crumbsData={blogStatic.crumbs_nav} crumbsCat={data.strapiCategory}/>
    </Layout>
  );
};

export default blogCategory;

export const query = graphql`
  query CategoryBlog($language: String!, $id: Int!) {

   article: allStrapiBlogArticles(filter: { category: { id: { eq: $id } } }) {
        edges {
            node {
                strapiId
                slug
                article {
                    id
                    title_ua
                    title_ru
                    time_ua
                    time_ru
                    date
                }
                category {
                    slug
                    title_ua
                    title_ru
                }
            }
        }
    }
    strapiBlog {
        main {
          title_01_ua
          title_02_ua
          title_01_ru
          title_02_ru
        }
    }
    allStrapiCategory {
      nodes {
        title_ua
        title_ru
        slug
      }
    }

    strapiCategory {
      title_ua
        title_ru
        slug
    }

    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
